import type React from "react";

const Logout: React.FC = () => <p>logout page</p>;

export default Logout;
